import { createUseStyles } from 'react-jss'

import customColors from './config/colors'

import { forPhoneOnly } from './config/mediaQueries'
import { palette } from '@dentalux/ui-library-core/constants/colors'

export default createUseStyles(
  {
    '@global': {
      '@font-face': {
        fontFamily: 'proxima-nova-light',
        src: 'url("/fonts/ProximaNova-Light.ttf")',
      },
      body: {
        margin: 0,
      },
      '#availy': {
        height: '100%',
        font: '16px -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        color: palette.grey!!['800'],
      },
    },
    asModal: {
      position: 'fixed',
      left: 0,
      top: 0,
      height: '100%',
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      paddingTop: '5vh',
      zIndex: 2000,
      '& $appContainer': {
        maxHeight: '90vh',
        [forPhoneOnly]: {
          maxHeight: 'unset',
          maxWidth: 'unset',
        },
      },
      [forPhoneOnly]: {
        paddingTop: 0,
      },
    },
    backdrop: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: customColors.black,
      transitions: [200, 'ease', 'opacity'],
      transitionDelay: 200,
      opacity: 0.7,
      '&$modalVisible': {
        opacity: 0.7,
      },
    },
    modalVisible: {},
    appContainer: {
      position: 'relative',
      fontFamily: 'Roboto',
      margin: [0, 'auto'],
      overflow: 'hidden',
      width: '100%',
      minWidth: 700,
      height: '100%',
      background: customColors.white,
      maxWidth: '80vw',
      color: palette.grey!!['800'] || 'grey',
      [forPhoneOnly]: {
        height: '100%',
        maxHeight: 'unset',
        minWidth: 'unset',
        maxWidth: 'unset',
        boxSizing: 'border-box',
      },

      '& input': {
        width: '100%',
        border: [1, 'solid', customColors.galery],
        boxSizing: 'border-box',
        margin: [10, 10],
        padding: [10, 20],
        fontFamily: 'proxima-nova-light, Roboto',
        fontSize: 14,
        backgroundColor: customColors.white,
        WebkitAppearance: 'none',
        MozAppearance: 'none',
        appearance: 'none',
        borderRadius: 0,
        '&::placeholder': {
          color: palette.grey!![600] || 'grey',
        },
      },
    },
    nonModalEmbed: {
      height: 'auto',
      maxWidth: '100%',
    },
    asModalEmbedded: {
      maxWidth: '80vw',
      [forPhoneOnly]: {
        height: '100vh',
      },
    },
  },
  { name: 'availy' }
)
